import { Translation as Tr } from "../class/Translation.js";

var ZahPrazdnyKosik = {
  Cart: false,
  Widget: false,

  _init: function() {
    Lc.f("ZahPrazdnyKosik.init");

    ZahPrazdnyKosik.nactiPrvky();
    if (!ZahPrazdnyKosik.Cart.length) return;

    ZahPrazdnyKosik.Cart.on(
      "mouseenter.ladzoPrazdnyKosik",
      ZahPrazdnyKosik.onCartMouseEnter,
    );
  },

  nactiPrvky: function() {
    ZahPrazdnyKosik.Cart = $(
      'a.toggle-window[data-target="cart"][data-testid="headerCart"]',
    );

    ZahPrazdnyKosik.Widget = $("#cart-widget");
  },

  jePrazdny: function() {
    if (
      typeof window.getShoptetDataLayer === "function" &&
      window.getShoptetDataLayer("cart")
    ) {
      return window.getShoptetDataLayer("cart").length === 0;
    }

    return true;
  },

  onCartMouseEnter: function() {
    Lc.f("ZahPrazdnyKosik.onCartMouseEnter");
    Lc.h("najeto");

    ZahPrazdnyKosik.nactiPrvky();

    if (!ZahPrazdnyKosik.Widget.length) return;

    if (ZahPrazdnyKosik.jePrazdny()) {
      ZahPrazdnyKosik.Cart.addClass("full");
      ZahPrazdnyKosik.Widget.addClass("ladzo-kosik-prazdny");

      if (!ZahPrazdnyKosik.Widget.find(".kos-prazdny").length) {
        ZahPrazdnyKosik.Widget.prepend(ZahPrazdnyKosik.vratHtml());
        ZahPrazdnyKosik.Widget.find(".cart-widget-products-inner").html("");
      }
    } else {
      //ZahPrazdnyKosik.Cart.removeClass("full");
      ZahPrazdnyKosik.Widget.removeClass("ladzo-kosik-prazdny");
      ZahPrazdnyKosik.Widget.find(".kos-prazdny").remove();
    }
  },

  vratHtml: function() {
    const O = window.DefLadzo.otevreno;

    return `
      <div class="kos-prazdny">
        <div class="kos-prazdny__inner">

          <h3 class="kos-prazdny__nazev">
            ${Tr.l("kos_prazdny_nazev")}
          </h3>

          <div class="kos-prazdny__text">
            ${Tr.l("kos_prazdny_text", {
              url: "/",
            })}
          </div>

          <div class="kos-prazdny__kontakt">
            <div class="kos-prazdny__foto"></div>

            <div class="kos-prazdny__udaje">
              <a href="tel:+420774737410" class="kos-prazdny__telefon">
                +420 774 737 410
              </a>

              <div class="kos-prazdny__cas">
                <span>(${Tr.l("detail_otevreno_po_pa")} ${O.od}–${O.do})</span>
              </div>
              

              <a href="mailto:info@5mfencing.com" class="kos-prazdny__email">
                info@5mfencing.com
              </a>
            </div>
          </div>

        </div>
      </div>
    `;
  },
};

export { ZahPrazdnyKosik };
